import { render, staticRenderFns } from "./SchedaParticolare.vue?vue&type=template&id=2c88a488&"
import script from "./SchedaParticolare.vue?vue&type=script&lang=js&"
export * from "./SchedaParticolare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports